
import { defineComponent, computed, ref, onMounted } from "vue";
import type { IStudentsModel, IIdentitiesModel, ICountriesModel, IDepartmentsModel, IStatesModel } from "@/interfaces/modules/";
import IdentitiesServices from "@/api/Configuration/IdentitiesService";
import CountriesServices from "@/api/Location/CountriesService";
import DepartmentsServices from "@/api/Location/DepartmentsService";
import StatesServices from "@/api/Location/StatesService";

export default defineComponent({
  name: "PersonelInformation",
  props: {
    record: { type: Object as () => IStudentsModel, required: true },
    wasValidated: { type: Boolean, default: false } // NEW: comes from parent
  },
  emits: ["update:record"],
  setup(props, { emit }) {
    // Two-way proxy for `record`
    const recordProxy = computed<IStudentsModel>({
      get: () => props.record,
      set: (val) => emit("update:record", val),
    });

    // Dropdown data (loaded on mount)
    const Documents = ref<IIdentitiesModel[]>([]);
    const Country = ref<ICountriesModel[]>([]);
    const Department = ref<IDepartmentsModel[]>([]);
    const City = ref<IStatesModel[]>([]);

    const toNumber = (v: any) => (v === "" || v === null || v === undefined ? null : Number(v));

    // Immutable field update to ensure the computed setter triggers
    const updateField = (key: keyof IStudentsModel, value: any) => {
      recordProxy.value = { ...recordProxy.value, [key]: value };
    };

    const load = async () => {
      Documents.value = await IdentitiesServices.GetIdentities();
      Country.value = await CountriesServices.GetCountries();
      Department.value = await DepartmentsServices.GetDepartments();
      City.value = await StatesServices.GetStates();
    };

    onMounted(load);

    return {
      recordProxy,
      updateField,
      toNumber,
      Documents,
      Country,
      Department,
      City,
    };
  },
});
